<div style="border: 1px solid lightgray; padding: 20px; margin-bottom: 10px">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px">
    <h4 style="color: black">{{pageSummary.title}}</h4>
    <button class="btn btn-primary btn-assessor" (click)="handleModifyClick()">Modify</button>
  </div>
  <div *ngFor="let field of pageSummary.fields; let i = index; trackBy: trackByFn" [style.background-color]="i % 2 === 0 ? '#e6e6e6' : 'GhostWhite'">
    <div style="padding: 10px; display: flex; align-items: center">
      <div class="col-6">
        <p style="color: black; margin-bottom: 0"><b>{{field.label}}</b></p>
      </div>
      <div class="col-6">
        <p style="color: black; margin-bottom: 0; word-wrap: break-word">{{field.value}}</p>
      </div>
    </div>
    <ng-container *ngIf="i !== pageSummary.fields.length - 1">
      <hr style="margin-bottom: 0; margin-top: 0">
    </ng-container>
  </div>
</div>
